import NodeBarChart from './NodeBarChart';
import NodeDonutChart from './NodeDonutChart';
import NodeBooleanGauge from './NodeBooleanGauge';
import NodeFunnelChart from './NodeFunnelChart';
import NodeChecklistTable from './NodeChecklistTable';
import NodeStatTile from './NodeStatTile';
import NodeQuoteList from './NodeQuoteList';
import { CHART_TYPES } from './nodeChartSpec';

/**
 * Соответствие «тип графика → рендерер». Единственное место, где принимается это решение.
 *
 * До реестра выбор компонента был тернарником на два варианта, и пять серверных типов
 * рисовались одним и тем же столбчатым графиком. Новый тип теперь добавляется строкой
 * здесь, а не правкой условия внутри секции.
 *
 * `plotArea` — нужна ли рендереру подложка области графика: у recharts-графиков она есть,
 * у карточек из обычной вёрстки (воронка, чек-лист, стат-плитка) выглядела бы серой рамкой
 * вокруг таблицы.
 *
 * `ownsData` — рендерер тянет данные из своего эндпоинта, а не рисует общий агрегат карточки
 * (см. `buildRendererProps`).
 *
 * Динамика и тепловая карта здесь не перечислены: это не типы графиков, а виды карточки
 * (см. `resolveViews`), и подставляет их оболочка — они тянут данные из своих эндпоинтов,
 * а не из общего агрегата.
 */
const RENDERERS = {
  [CHART_TYPES.Bar]: { Component: NodeBarChart, plotArea: true },
  [CHART_TYPES.Donut]: { Component: NodeDonutChart, plotArea: true },
  [CHART_TYPES.BooleanGauge]: { Component: NodeBooleanGauge, plotArea: false },
  [CHART_TYPES.Funnel]: { Component: NodeFunnelChart, plotArea: false },
  [CHART_TYPES.ChecklistTable]: { Component: NodeChecklistTable, plotArea: false },
  [CHART_TYPES.Stat]: { Component: NodeStatTile, plotArea: false },
  [CHART_TYPES.QuoteList]: { Component: NodeQuoteList, plotArea: false, ownsData: true }
};

/**
 * Незнакомый тип не должен ронять дашборд: сервер может уйти вперёд фронтенда
 * (или наоборот), и столбцы — безопасный универсальный вид для любых категориальных данных.
 */
export const resolveRenderer = (chartType) => RENDERERS[chartType] ?? RENDERERS[CHART_TYPES.Bar];

/**
 * Пропсы рендерера. Рисующему агрегат хватает готовых строк (`viewProps`), а рендерер
 * с `ownsData` запрашивает данные сам, и ему нужен срез карточки (`queryProps`): период,
 * направление, фильтры панели.
 *
 * Раньше все рендереры получали один набор пропсов, и список цитат оставался без периода:
 * его запрос не уходил ни разу, и карточка всегда писала «Нет данных за выбранный период».
 */
export const buildRendererProps = (renderer, { viewProps, queryProps }) =>
  renderer?.ownsData ? { ...viewProps, ...queryProps } : viewProps;
